import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  getAllReminder(dateBegin = null) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder`;
    if (dateBegin) apiUrl += `?dateBegin=${dateBegin}`;
    return httpGet(apiUrl);
  }

  searchReminder(terms) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/search`;
    return httpPost(apiUrl, terms);
  }

  addReminder(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/`;

    return httpPost(apiUrl, data);
  }

  updateReminder(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/`;

    return httpPut(apiUrl, data);
  }

  closeReminder(_id, optUserID) {
    let data = { _id, optUserID };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/close`;

    return httpPut(apiUrl, data);
  }

  notifiedReminder(_id) {
    let data = { ids: [_id] };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/notified`;

    return httpPut(apiUrl, data);
  }

  batchNotifiedReminder(ids) {
    let data = { ids };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/notified`;

    return httpPut(apiUrl, data);
  }

  deleteReminder(_id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/`;

    return httpDelete(apiUrl, { _id });
  }

  deleteReminderByPet(petID, dateBegin) {
    let data = { petID, dateBegin };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/`;

    return httpDelete(apiUrl, data);
  }

  remindUser(_id, message, lineID, optUserID) {
    let data = { _id, message, lineID, optUserID };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/remindUser`;

    return httpPut(apiUrl, data);
  }

  getRecordReminder(recordID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/list`;

    return httpPost(apiUrl, { recordID });
  }

  getPetReminder(petID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/list`;

    return httpPost(apiUrl, { petID });
  }

  getReminderTemplate(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/reminder/template/list`;

    return httpPost(apiUrl, data);
  }
}
